<fgb-mobile-page-header [pageTitle]="'lotto.page.title'" backButtonLink="/" />
<fgb-banner class="d-lg-block d-none" [title]="'lotto.page.title' | translate" />

<div class="container mobile-container">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

  <div class="mt-3">
    <fgbcl-lottos-list-v2 [isList]="true" [defaultSort]="0" />
  </div>
</div>
